import styled from "styled-components";

import { ReactComponent as ChevronDownIcon } from 'assets/icons/white_chevron_down.svg';

export const Container = styled.div`
  .select-withdraw-option__withdraw-option {
    background: transparent;
    border: none;

    width: 100%;
    padding: 1.5rem 1rem 1.5rem 2rem;

    display: flex;
    align-items: center;
    gap: 1.5rem;

    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 1rem;

    cursor: pointer;

    transition: outline 0.1s;

    &:hover {
      outline: 3px solid var(--blue00);
    }
  }

  .select-withdraw-option__option__icon {
    width: 2rem;
    height: 3rem;

    align-self: flex-start;
  }

  .select-withdraw-option__withdraw-option__info-wrapper {
    height: 100%;

    display: flex;
    flex-direction: column;

    gap: 0.875rem;
  }

  .select-withdraw-option__withdraw-option__title {
    text-align: left;
    font-size: 2rem;
    font-weight: bold;
    color: var(--blue00);
  }

  .select-withdraw-option__withdraw-option__subtitle {
    color: #B6B6B6;
    font-size: 1rem;
  }

  .select-withdraw-option__withdraw-option__arrow {
    margin-left: auto;
  }
`;

export const RightArrowIcon = styled(ChevronDownIcon)`
  transform: rotate(270deg);

  > * {
    fill: #6F6F6F;
  }
`;
